export default __webpack_public_path__ + "static/media/vinyl-top-layer.b56c3ccf.svg";